import { createRoutableExtension } from '@backstage/core-plugin-api';
import { techInsightsPlugin } from '@backstage-community/plugin-tech-insights';

export const BidoneScorecardsRoutablePage = techInsightsPlugin.provide(
  createRoutableExtension({
    name: 'BidoneScorecardsPage',
    component: () =>
      import('./BidoneScorecardsPage').then(m => m.BidoneScorecardsPage),
    mountPoint: techInsightsPlugin.routes.root,
  }),
);
